import { GetTeamsBySalesforceAccountIdResponse } from '@cbinsights/userv2service/userv2service';
import { UseQueryResult, useQuery } from 'react-query';
import { GetTeamsBySalesforceAccountId } from '.';
import { getTeamsBySalesforceAccountId } from '../api/GetTeamsBySalesforceAccountIdQuery';

type Params = Parameters<typeof getTeamsBySalesforceAccountId>[0];
type Return = GetTeamsBySalesforceAccountIdResponse;

export const useGetTeamsBySalesforceAccountId = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetTeamsBySalesforceAccountId, Params]>(
    ['GetTeamsBySalesforceAccountId', params],
    () => getTeamsBySalesforceAccountId(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );

export default useGetTeamsBySalesforceAccountId;
